var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tw-h-[40px] tw-min-w-[189px] tw-px-4 tw-border tw-rounded-md tw-text-sm",class:_vm.buttonStyles,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }